<!--@if(isBrowser) {-->
<!-- Top Progress Loader -->

<!-- Main Loader -->
@if ((templateConfig$ | async)?.header?.visible) {
  <app-header [sticky]="true"></app-header>
}
<router-outlet></router-outlet>
@if ((templateConfig$ | async)?.footer?.visible) {
  <app-footer></app-footer>
}

<!--}-->
